module.exports = __webpack_public_path__ + "static/media/faq-banner.37b61930.png";